import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';

import { Table, Badge } from 'antd';

class AlertsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {}
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  render() {
    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Čas události',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 150,
      defaultSortOrder: 'descend',
      sorter: (a, b) => dateSorter(a.timestamp, b.timestamp),
      render: (text, record) => (
        <span>{text ? moment(text).format('L LTS') : null}</span>
      ),
    }, {
      title: 'Modul',
      dataIndex: 'module',
      key: 'module',
      width: 150,
      sorter: (a, b) => defaultSorter(a.module, b.module),
    }, {
      title: 'Úroveň',
      dataIndex: 'level',
      key: 'level',
      width: 100,
      sorter: (a, b) => defaultSorter(a.level, b.level),
    }, {
      title: 'Zpráva',
      dataIndex: 'message',
      key: 'message',
    }, {
      title: 'Reportováno',
      dataIndex: 'reported',
      key: 'reported',
      width: 130,
      filters: [{
        text: 'ANO',
        value: true,
      }, {
        text: 'NE',
        value: false,
      }],
      filteredValue: filteredInfo.reported || null,
      onFilter: (value, record) => { return ((record.reported === (value == 'true'))) ? true : false },
      render: (text, record) => {
        if (record.reported === true) {
          return (
            <Badge
              status="success"
              text="ANO" />
          );
        } else {
          return (
            <Badge
              status="error"
              text="NE" />
          );
        }
      }
    }]

    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={columns}
        dataSource={this.props.data}
        style={{ border: '0px' }}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        onChange={this.handleChange} />
    );
  }
}

export default AlertsTable;


// WEBPACK FOOTER //
// ./src/components/AlertsTable.js